<template>
  <div>
    {{label}}
    <v-layout row　align-right v-if="!readOnly">
      <v-flex md3>
        <v-text-field
          class="input-item"
          v-model.number="year"
          suffix="年"
          type="number"
          @blur="updateYear"
          :error-messages="yearErrorMessage"
        />
      </v-flex>
      <v-flex md2>
        <v-select class="input-item " :items="months" v-model="month" suffix="月"/>
      </v-flex>
      <v-flex md2>
        <v-select class="input-item" :items="dates" v-model="date" suffix="日"/>
      </v-flex>
      <v-flex md2>
        <v-select class="input-item" :items="hours" v-model="hour" suffix="時"/>
      </v-flex>
      <v-flex md2>
        <v-select class="input-item" :items="minutes" v-model="minute" suffix="分"/>
      </v-flex>
    </v-layout>
        <v-layout row　align-right v-if="readOnly">
      <v-flex md11 style="font-size: 16px;">
        {{toJapaneseDatetime(value)}}
      </v-flex>

    </v-layout>
  </div>
</template>
<script>
import { getMoment, validDateToUnixtime, unixtimeToJapaneseFormattedDatetime } from "@/utils/datetime";

const moment = getMoment();

export default {
  props: {
    upperLimmitOfYear: {
      type: Number,
      default: 2020
    },
    lowerLimmitOfYear: {
      type: Number,
      default: 1900
    },
    value: {
      // unixtime
      type: Number,
      required: true
    },
    label: {
      type: String,
      default: "生年月日"
    },
    readOnly:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      yearError: { code: "no-error", message: "" },
      hours: [
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        1,
        2,
        3,
        4,
        5,
        6
      ],
      minutes: [0, 10, 20, 30, 40, 50]
    };
  },
  computed: {
    years() {
      return range(this.lowerLimmitOfYear, this.upperLimmitOfYear);
    },
    months() {
      return range(1, 12);
    },
    dates() {
      const nDays = moment([this.year, this.month - 1, this.date])
        .endOf("month")
        .date();
      return range(1, nDays);
    },

    year: {
      get() {
        const m = moment.unix(this.value);
        return m.year();
      },
      set(year) {
        if (moment([year, 0, 1]).isValid()) {
          this.updateValue({ year });
        }
      }
    },
    month: {
      get() {
        const m = moment.unix(this.value);
        return m.month() + 1;
      },
      set(month) {
        this.updateValue({ month });
      }
    },
    date: {
      get() {
        const m = moment.unix(this.value);
        return m.date();
      },
      set(date) {
        this.updateValue({ date });
      }
    },
    hour: {
      get() {
        const m = moment.unix(this.value);
        return m.hour();
      },
      set(hour) {
        this.updateValue({ hour });
      }
    },
    minute: {
      get() {
        const m = moment.unix(this.value);
        return m.minute();
      },
      set(minute) {
        this.updateValue({ minute });
      }
    },
    yearErrorMessage() {
      if (
        this.yearError &&
        "code" in this.yearError &&
        this.yearError.code != "no-error"
      ) {
        return this.yearError.message;
      } else {
        return "";
      }
    }
  },
  methods: {
    updateYear() {
      if (
        moment([this.year, 0, 1]).isValid() &&
        this.year <= this.upperLimmitOfYear &&
        this.year >= this.lowerLimmitOfYear
      ) {
        this.updateError({ code: "no-error", message: "" });
        this.updateValue({ year: this.year });
      } else {
        const error = {};
        error.code = "year-out-of-range";
        error.message =
          String(this.lowerLimmitOfYear) +
          "以上、" +
          String(this.upperLimmitOfYear) +
          "以下の半角数字を入力してください。";
        this.updateError(error);
      }
    },
    updateValue(change) {
      const { year, month, date, hour, minute } = this;
      const args = { year, month, date, hour, minute, ...change };
      this.$emit(
        "input",
        validDateToUnixtime([args.year, args.month - 1, args.date, args.hour, args.minute])
      );
    },
    updateError(error) {
      this.$emit("update:error", error);
      this.yearError = Object.assign({}, this.yearError, error);
    },
    toJapaneseDatetime(unixtime){
      return unixtimeToJapaneseFormattedDatetime(unixtime)
    }
  }
};

function range(min, max) {
  const a = [];
  for (let i = min; i <= max; ++i) {
    a.push(i);
  }
  return a;
}
</script>
<style lang="scss" scoped>
.input-item {
  margin-right: 15px;
}

</style>
